import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Pop } from 'src/app/classes/shared/pop';
import { User } from 'src/app/interfaces/api/user';
import { AuthService } from 'src/app/services/core/auth.service';
import { WebSocketService } from 'src/app/services/core/web-socket.service';

@Component({
  selector: 'app-notify',
  imports: [CommonModule],
  templateUrl: './notify.component.html',
  styleUrl: './notify.component.scss'
})
export class NotifyComponent implements OnInit, OnDestroy {

  destroy$ = new Subject<void>();
  alertSub: any;
  audioSub: any;
  user: User;

  //fullscreen
  dismissed: boolean = true;
  // lastAlert = { message: "", color: "danger", duration: 5000, fontSize: "24px" };
  lastAlert = signal({ message: "", color: "danger", duration: 5000, fontSize: "24px" });
  alertPaused: boolean = false;
  timeoutAlert: any;

  //header
  headerAlert = signal({ message: "", color: "danger" })
  //audio
  shortBeep: HTMLAudioElement = new Audio();
  longBeep: HTMLAudioElement = new Audio();
  timeoutAudio: any;
  audioEventPaused = false;

  constructor(
    public pop: Pop,
    private auth: AuthService,
    private socket: WebSocketService
  ) {
    this.user = this.auth.currentUser();
    this.shortBeep.src = `/sounds/short_beep.mp3`;
    this.longBeep.src = `/sounds/long_beep.mp3`;
    this.shortBeep.load();
    this.longBeep.load();
  }

  ngOnInit() {
    this.initSockets();

  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initSockets() {
    var audioSource: any;
    var voices: any[] = [];

    if ('speechSynthesis' in window) {
      voices = window.speechSynthesis.getVoices();
      window.speechSynthesis.onvoiceschanged = function () {
        voices = window.speechSynthesis.getVoices();
      }
    }

    if (!this.alertSub) {
      this.alertSub = this.socket.on("alert").pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
        try {

          var currentUserId = this.user.id;

          if (data.users.length && data.users.indexOf(currentUserId) == -1) {
            return;
          }

          if (data.display == "fullscreen") {
            this.alertFullscreen(data.message, data.colorType, parseFloat(data.duration) * 1000, data.fontSize)

          } else if (data.display == "header") {
            this.headerAlert.set({
              message: data.message,
              color: data.colorType
            })
          } else {

            this.pop.toast(data.message, data.colorType, parseFloat(data.duration) * 1000)
          }

        } catch (e) {
          console.error(e);
        }
      });
    }
    if (!this.audioSub) {
      this.audioSub = this.socket.on("audio").pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
        try {
          
          if (data.reset) {
            if (audioSource) {
              // Stop the current audio source immediately
              audioSource.disconnect();
              audioSource.stop(0);
              audioSource = null;
              // events.emit('ui-audio', 'reset');
            } else if (window.speechSynthesis.speaking) {
              window.speechSynthesis.cancel();
              // events.emit('ui-audio', 'reset');
            }
            return;
          }
          var currentUserId = this.user.id;

          if (data.users.length && data.users.indexOf(currentUserId) == -1) {
            return;
          }

          if (data.audio) {
            if (!window.hasOwnProperty("AudioContext")) {
              return
            }
            // if (window.AudioContext) alert("This Browser does not support Audio context");
            try {

              if (data.audio == "short_beep") {

                this.shortBeep.currentTime = 0;
                this.shortBeep.volume = data.volume ? data.volume / 100 : 0.75;
                this.shortBeep.play();

              } else {

                this.longBeep.currentTime = 0;
                this.longBeep.volume = data.volume ? data.volume / 100 : 0.75;
                this.longBeep.play();

              }

            } catch (e) {
              console.error(e);
              // events.emit('ui-audio', 'error'); 
            }
          } else if (data.tts) {
            if (voices.length > 0) {
              var words = new SpeechSynthesisUtterance(data.tts);
              words.volume = data.volume ? data.volume / 100 : 0.75;
              // words.onerror = function(err) { events.emit('ui-audio', 'error: '+err.error); }
              // words.onend = function(event) { events.emit('ui-audio', 'complete'); }
              let voiceIndex = 0;
              if (data.voiceName)
                voiceIndex = voices.findIndex(v => v.name == data.voiceName)
              if (voiceIndex == -1)
                voiceIndex = voices.findIndex(v => v.lang == data.voice)
              if (voiceIndex == -1)
                voiceIndex = 0;

              words.voice = voices[voiceIndex];
              // events.emit('ui-audio', 'playing');
              window.speechSynthesis.speak(words);
            } else {

              alert("This Browser does not support Text-to-Speech");

            }
          }
        } catch (e) {
          console.error(e)
        }
      })
    }
  }

  alertFullscreen(message: string, color: string = "danger", duration: number = 5000, fontSize = "24px") {
    if (message == this.lastAlert().message || this.alertPaused) {
      return;
    }

    this.lastAlert.set({ message, color, duration, fontSize });

    setTimeout(() => {
      this.dismiss()
    }, duration)

  }
  dismissHeader(): void {

    this.headerAlert.set({ message: "", color: "danger" });
  }
  dismiss(): void {

    this.alertPaused = true;
    this.timeoutAlert = setTimeout(() => {
      this.alertPaused = false;
    }, 1000)
    this.lastAlert.set({ message: "", color: "danger", duration: 5000, fontSize: "24px" });
  }
}
